module.exports = __webpack_public_path__ + "static/media/ledlamp.205f879e.png";